"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SizeType;
(function (SizeType) {
    SizeType["XS"] = "xs";
    SizeType["SM"] = "sm";
    SizeType["MD"] = "md";
    SizeType["LG"] = "lg";
})(SizeType = exports.SizeType || (exports.SizeType = {}));
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/tinyYolov2/types.js
// module id = 298
// module chunks = 0